export { default }from './PaymentCheck';